module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_zh-hant-82b0bac3f8ad60105460492576f6c472.jpg";